<div class="search-bar-container">
  <div class="search-input-group">
    <div class="search-input-wrapper">
      <span class="search-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </span>
      <input type="text" [value]="value" (input)="onSearchChange($event)" (keyup.enter)="onSearch()"
        [placeholder]="'searchBar.placeholder' | translate" class="search-input" />
      @if (value) {
      <button class="btn-clear" (click)="onClear()" aria-label="Clear search">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      }
    </div>
    <button class="btn-search" (click)="onSearch()">{{ 'searchBar.button' | translate }}</button>
  </div>

  @if (isAdvancedSearchAvailable) {

  <button class="btn-advanced" (click)="onToggleAdvanced()">
    <span class="advanced-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round">
        <circle cx="7" cy="8" r="2"></circle>
        <line x1="9" y1="8" x2="21" y2="8"></line>
        <line x1="3" y1="8" x2="5" y2="8"></line>
        <circle cx="17" cy="16" r="2"></circle>
        <line x1="3" y1="16" x2="15" y2="16"></line>
        <line x1="19" y1="16" x2="21" y2="16"></line>
      </svg>
    </span>
    {{ 'searchBar.advanced' | translate }}
  </button>
  }

</div>